import { render, staticRenderFns } from "./appearanceDppm.vue?vue&type=template&id=4fb73dc3&scoped=true&"
import script from "./appearanceDppm.vue?vue&type=script&lang=js&"
export * from "./appearanceDppm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb73dc3",
  null
  
)

export default component.exports